import { render, staticRenderFns } from "./my-invest.vue?vue&type=template&id=082f5662"
import script from "./my-invest.vue?vue&type=script&lang=js"
export * from "./my-invest.vue?vue&type=script&lang=js"
import style0 from "./my-invest.vue?vue&type=style&index=0&id=082f5662&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports